import { lazy } from 'react'

// Single source of truth mapping a modal key to its (lazily loaded) component.
// Add a new modal here + a file under src/modals — no if/else chains to edit.
export const MODAL_REGISTRY = {
  'create-searchroom': lazy(() => import('../../modals/searchroom/CreateSearchroomModal')),
  'edit-searchroom': lazy(() => import('../../modals/searchroom/EditSearchroomModal')),
  'searchroom-search': lazy(() => import('../../modals/searchroom/SearchroomSearchModal')),
  'create-global-chat': lazy(() => import('../../modals/globalsearch/GlobalChatFormModal')),
  'edit-global-chat': lazy(() => import('../../modals/globalsearch/GlobalChatFormModal')),
  'create-text-search': lazy(() => import('../../modals/globaltextsearch/TextSearchFormModal')),
  'edit-text-search': lazy(() => import('../../modals/globaltextsearch/TextSearchFormModal')),
  'create-bookmark': lazy(() => import('../../modals/bookmark/CreateBookmarkModal')),
  'edit-bookmark': lazy(() => import('../../modals/bookmark/EditBookmarkModal')),
  'create-topic': lazy(() => import('../../modals/bookmark/CreateTopicModal')),
  'refile-topic': lazy(() => import('../../modals/topics/RefileTopicModal')),
  'move-topic': lazy(() => import('../../modals/topics/MoveTopicModal')),
  'edit-topics': lazy(() => import('../../modals/bookmark/EditTopicsModal')),
  confirm: lazy(() => import('../../modals/common/ConfirmModal')),
  'rename-notebook': lazy(() => import('../../modals/notebook/NotebookRenameModal')),
  'notebook-items': lazy(() => import('../../modals/notebook/NotebookItemsModal')),
  'comment-items': lazy(() => import('../../modals/comment/CommentItemsModal')),
  'comment-topics': lazy(() => import('../../modals/comment/CommentTopicsModal')),
  'comment-likes': lazy(() => import('../../modals/comment/CommentLikesModal')),
  'guide-form': lazy(() => import('../../modals/guide/GuideFormModal')),
  'guide-view': lazy(() => import('../../modals/guide/GuideViewerModal')),
  'profile-edit': lazy(() => import('../../modals/network/ProfileEditModal')),
  'create-chat': lazy(() => import('../../modals/chatroom/CreateChatModal')),
  'chat-text': lazy(() => import('../../modals/chatroom/ChatTextModal')),
  'chat-people': lazy(() => import('../../modals/chatroom/ChatPeopleModal')),
  'chat-topics': lazy(() => import('../../modals/chatroom/ChatTopicsModal')),
  'chat-attach': lazy(() => import('../../modals/chatroom/ChatAttachModal')),
  'chat-details': lazy(() => import('../../modals/chatroom/ChatDetailsModal')),
  'chat-likes': lazy(() => import('../../modals/chatroom/ChatLikesModal')),
  'answer-to-note': lazy(() => import('../../modals/answer/AnswerToNoteModal')),
  'answer-to-chat': lazy(() => import('../../modals/answer/AnswerToChatModal')),
}
